import { MDBPagination, MDBPaginationItem, MDBPaginationLink } from 'mdb-react-ui-kit';
import React from 'react';

class Pagination extends React.Component<{ onPageChange: Function, currentPage: number, totalPages: number, maxVisible: number }> {

    state = {

    }

    createPageItem(label: any, page: any, isActive = false, isDisabled = false) {
        return (
            <MDBPaginationItem
                key={`${label}-${page}`}
                active={isActive}
                disabled={isDisabled}
            >
                <MDBPaginationLink
                    href={`?page=${this.props.currentPage}`}
                    onClick={(e) => {
                        e.preventDefault();
                        if (!isDisabled && this.props.currentPage !== page) {
                            this.props.onPageChange(page);
                        }
                    }}
                >
                    {label}
                </MDBPaginationLink>
            </MDBPaginationItem>
        );
    }

    renderPages() {
        const { totalPages, currentPage, maxVisible = 2 } = this.props;
        const items = [];

        // Previous button
        items.push(
            this.createPageItem('«', currentPage - 1, false, currentPage === 1)
        );

        // Always show the first page
        items.push(this.createPageItem(1, 1, currentPage === 1));

        const start = Math.max(2, currentPage - maxVisible);
        const end = Math.min(totalPages - 1, currentPage + maxVisible);

        // Show leading ellipsis if the range starts after page 2
        if (start > 2) {
            items.push(
                <MDBPaginationItem disabled key="start-ellipsis">
                    <MDBPaginationLink href="#!">...</MDBPaginationLink>
                </MDBPaginationItem>
            );
        }

        // Pages between start and end
        for (let i = start; i <= end; i++) {
            items.push(this.createPageItem(i, i, currentPage === i));
        }

        // Show trailing ellipsis if the range ends before the last page
        if (end < totalPages - 1) {
            items.push(
                <MDBPaginationItem disabled key="end-ellipsis">
                    <MDBPaginationLink href="#!">...</MDBPaginationLink>
                </MDBPaginationItem>
            );
        }

        // Always show the last page if totalPages > 1
        if (totalPages > 1) {
            items.push(
                this.createPageItem(totalPages, totalPages, currentPage === totalPages)
            );
        }

        // Next button
        items.push(
            this.createPageItem('»', currentPage + 1, false, currentPage === totalPages)
        );

        return items;
    }

    render() {
        return (
            <MDBPagination className="mb-0 justify-content-center gap-1">
                {this.renderPages()}
            </MDBPagination>
        );
    }
}

export default Pagination;